module.exports = __webpack_public_path__ + "img/home_logo_v2.2f8a89c1.png";